import {ChangeDetectorRef, Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {StateService, PropertyLineModel, WebUserModel} from "web-shared";
import {takeUntil} from "rxjs/operators";
import {BaseComponent, GLOBAL, IdCodeNameModel, IdTextValueModel} from "common-shared";
import {plainToInstance} from "class-transformer";
import {ResourceService} from "../../../../manufacturing/resources/resource.service";

@Component({
  selector: 'app-favourites-toggle',
  templateUrl: './favourites-toggle.component.html',
  styles: []
})
export class FavouritesToggleComponent extends BaseComponent implements OnInit {
  isFavourite: boolean = false;
  @Input() model: IdCodeNameModel;
  @Input() route: string;

  constructor(private stateService: StateService, private resourceService: ResourceService, private changeDetector: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.changeDetector.detach();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.model && changes.model.currentValue !== undefined) {
      this.determineIsFavourite();
    }
  }

  determineIsFavourite(): void {
    this.stateService.currentUser$.pipe(takeUntil(this.componentDestroyed)).subscribe(currentUser => {
      const favourites = this.getFavourites(currentUser);
      if (favourites?.length) {
        this.isFavourite = favourites.some(f => f.Value.includes(this.model.Id));
      }
      this.changeDetector.detectChanges();
    });
  }

  private getFavourites(user: WebUserModel): IdTextValueModel[] {
    const favouritesSpec = user.Specs?.find(spec => spec.PropertyId === GLOBAL.Properties.Favourites);
    if (favouritesSpec?.Value) {
      return plainToInstance(IdTextValueModel, <string[]>JSON.parse(favouritesSpec.Value));
    } else {
      return null;
    }
  }

  toggleFavouriteStatus(): void {
    let currentUser = this.stateService.currentUser$.value;
    this.updateFavouritesSpec(currentUser, this.route + this.model.Id).pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
      this.resourceService.getCurrentUserSpecs().pipe(takeUntil(this.componentDestroyed)).subscribe(specs => {
        currentUser.Specs = specs;
        this.stateService.currentUser$.next(currentUser);
      });
    });
  }

  updateFavouritesSpec(user: WebUserModel, route: string) {
    if (this.isFavourite) {
      let favourites = this.getFavourites(user);
      favourites = favourites.filter(f => !f.Value.includes(this.model.Id));
      let propertyLine = new PropertyLineModel();
      propertyLine.Id = user.Specs.find(spec => spec.PropertyId === GLOBAL.Properties.Favourites)?.LineId;
      propertyLine.PropertyId = GLOBAL.Properties.Favourites;
      propertyLine.Value = JSON.stringify(favourites);
      return this.resourceService.editPropertyLine(propertyLine);
    } else {
      return this.resourceService.addCurrentUserListPropertyLineValue(GLOBAL.Properties.Favourites, route, this.model.DisplayName);
    }
  }
}
